import {
  ResolutionDiscount,
  ResolutionExchange,
  ResolutionExchangeCredit,
  ResolutionRefund,
} from "@/pages/(app)/returns/list/components/icons/filters-icons";
import useTranslation from "@babackapp/translations/use-translation";

const resolutions = {
  refund: {
    label: "misc.refund",
    value: "refund",
    Icon: ResolutionRefund,
  },
  exchange: {
    label: "misc.exchange",
    value: "exchange",
    Icon: ResolutionExchange,
  },
  "exchange-credit": {
    label: "misc.exchange-credit",
    value: "exchange-credit",
    Icon: ResolutionExchangeCredit,
  },
  discount: {
    label: "misc.discount",
    value: "discount",
    Icon: ResolutionDiscount,
  },

  "new-articles": {
    label: "misc.new-articles",
    value: "new-articles",
    Icon: ResolutionExchange,
  },
} as const;

export default function useResolutionContent(
  resolution?: keyof typeof resolutions | null,
) {
  const t = useTranslation();

  if (!resolution) {
    return null;
  }

  const result = {
    ...resolutions[resolution],
    label: t(resolutions[resolution].label),
  };

  return result;
}
